import Vue from 'vue';
import $ from 'jquery';
import {DirectiveBinding} from 'vue/types/options';



function MovingLineInit(el:HTMLElement, binding:DirectiveBinding) {


    // on supprimer au cas ou si nous avons deja une moving line
    /*
    let existingMovingLine = $(el).find('.mlTitle__bar');
    if(existingMovingLine.length){
        if(existingMovingLine.width() == 0){
            $(el).find('.mlTitle__bar').remove();
        } else {
            return;
        }
    }
    */

    let delay = 1000;
    if('value' in binding){
        if('delay' in binding.value){
            delay = parseInt(binding.value.delay);
        }
    }

    setTimeout(() => {

        const curent = $(el);

        const cWidth = curent.width() || 0;
        const lineHeight = Math.floor(parseInt(curent.css('fontSize')) / 5); // on calcul la taille de la line automatiquement, taille de la police % 5
        const lineWidthMin = cWidth * 0.2; // definie la largeur minimum
        const lineWidthMax = cWidth * 0.75; // definie la largeur maximum
        const lineWidth = Math.random() * (lineWidthMax - lineWidthMin) + lineWidthMin;

        const lineOffsetXMin = -cWidth * 0.3; // décalage minimum équivant a 10% du titre
        const lineOffsetXMax = cWidth - lineWidth; // décalage maximum équivaut a la taille du titre - la taille de la line, comme ca elle ne sort jamais du container
        let lineOffsetX = (Math.random() * (lineOffsetXMax - lineOffsetXMin) + lineOffsetXMin) * 0.6; // Le 0.5 correspond a un ratio arbitraire qui est moduable

        // on va faire un minimum de -20px pour eviter des chevauchements
        lineOffsetX = Math.max(lineOffsetX, 30);

        curent.addClass('mlTitle');

        const movingBar = $('<span />')
            .addClass('mlTitle__bar')
            .css({
                bottom: -lineHeight * 2.2, // le décallage est relatif a la taille de la moving line
                height: lineHeight,
                left: lineOffsetX,
            })
            .appendTo($(el));

        movingBar.css({
            transform: 'translateX(" + lineOffsetX + "px)',
            width: lineWidth,
        });
    }, delay);
};

Vue.directive('movingLine', {

    inserted: (el, binding) => {
        MovingLineInit(el, binding);
    },

});
